export const Spacing = Object.freeze({
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 40,
});

export type SpacingToken = keyof typeof Spacing;

export const Radius = Object.freeze({
  xs: 6,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pill: 999,
});

export type RadiusToken = keyof typeof Radius;
